import type { OrgKnowledge, RovoApp } from './types';

export const getAppFilters = (orgKnowledge: OrgKnowledge): RovoApp[] | undefined => {
	if (orgKnowledge === 'disabled') {
		// no org knowledge applied at all.
		return [];
	} else if (orgKnowledge.filteredApps.length === 0) {
		// all org knowledge applied and no apps filtered.
		return undefined;
	} else {
		// org knowledge applied and apps filtered.
		return orgKnowledge.filteredApps;
	}
};
